export const chargepointTotal = {
	total: '70,000',
};
